import axios from "axios";
import store from "../redux/store";
import { showToastAction } from "../redux/toastSlice";

export default async function getFormDetails(project_name) {
    try {
        const res = await axios.get(`/project/${project_name}/forms-details`);
        return res.data?.data;
    }
    catch (err) {
        store.dispatch(showToastAction({ message: err.response?.data?.errorMessage ?? "Error", showToast: true }))
    }
}